// UploadModalMediaThumbnail.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StatefulImage from '../component/StatefulImage.jsx';

import PlayIconSource from '../../img/ic_grid_video.svg';
import MultipleIconSource from '../../img/btn_post_24.svg';

export const UploadModalMediaThumbnail = ({
  posterObjectUrl,
  objectUrl,
  contentType,
  isMultipleAssets,
  shouldShowPostTypeIcon,
}) => {
  const isVideo = /video\//i.test(contentType);
  const isImage = /image\//i.test(contentType);
  if (!objectUrl || !contentType || (!isVideo && !isImage)) {
    return null;
  }
  return (
    <StyledUploadModalMediaThumbnail>
      {isVideo && !posterObjectUrl ? (
        <VideoPreview
          src={objectUrl}
          playsInline
          muted
          onLoadedMetadata={({ target }) => target.play()}
          onPlay={({ target }) => target.pause()}
        />
      ) : (
        <StatefulImage>
          <ImagePreview data-key="target" src={posterObjectUrl || objectUrl} />
        </StatefulImage>
      )}
      {shouldShowPostTypeIcon ? (
        isMultipleAssets ? (
          <ThumbnailSourceIcon src={MultipleIconSource} aria-hidden />
        ) : isVideo ? (
          <ThumbnailSourceIcon src={PlayIconSource} aria-hidden />
        ) : null
      ) : null}
    </StyledUploadModalMediaThumbnail>
  );
};

UploadModalMediaThumbnail.propTypes = {
  objectUrl: PropTypes.string,
  posterObjectUrl: PropTypes.string,
  contentType: PropTypes.string,
  isMultipleAssets: PropTypes.bool,
  shouldShowPostTypeIcon: PropTypes.bool,
};

UploadModalMediaThumbnail.defaultProps = {
  objectUrl: null,
  posterObjectUrl: null,
  contentType: null,
  isMultipleAssets: false,
  shouldShowPostTypeIcon: false,
};

const StyledUploadModalMediaThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const VideoPreview = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ThumbnailSourceIcon = styled.img`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 14px;
  height: 14px;
  object-fit: contain;
`;

export default UploadModalMediaThumbnail;
